export default "__VITE_ASSET__reJPjBpb__"